import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "./main.css";
import { useSlotProps as $11MUV$useSlotProps, useStyleProps as $11MUV$useStyleProps, classNames as $11MUV$classNames, getWrappedElement as $11MUV$getWrappedElement } from "@react-spectrum/utils";
import { FocusRing as $11MUV$FocusRing } from "@react-aria/focus";
import { mergeProps as $11MUV$mergeProps } from "@react-aria/utils";
import $11MUV$react, { useRef as $11MUV$useRef } from "react";
import { useHover as $11MUV$useHover } from "@react-aria/interactions";
import { useLink as $11MUV$useLink } from "@react-aria/link";
import { useProviderProps as $11MUV$useProviderProps } from "@react-spectrum/provider";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $3c5235ac12f2c9bb$exports = {};
$parcel$export($3c5235ac12f2c9bb$exports, "Link", function () {
  return $3c5235ac12f2c9bb$export$a6c7ac8248d6e38a;
});
var $4564c6c10d1690b3$exports = {};
$parcel$export($4564c6c10d1690b3$exports, "spectrum-Link", function () {
  return $4564c6c10d1690b3$export$d85dd8b94975f388;
}, function (v) {
  return $4564c6c10d1690b3$export$d85dd8b94975f388 = v;
});
$parcel$export($4564c6c10d1690b3$exports, "is-hovered", function () {
  return $4564c6c10d1690b3$export$b8813cd5d7824ce7;
}, function (v) {
  return $4564c6c10d1690b3$export$b8813cd5d7824ce7 = v;
});
$parcel$export($4564c6c10d1690b3$exports, "focus-ring", function () {
  return $4564c6c10d1690b3$export$f39a09f249340e2a;
}, function (v) {
  return $4564c6c10d1690b3$export$f39a09f249340e2a = v;
});
$parcel$export($4564c6c10d1690b3$exports, "is-disabled", function () {
  return $4564c6c10d1690b3$export$d35bc1e505d1ebbf;
}, function (v) {
  return $4564c6c10d1690b3$export$d35bc1e505d1ebbf = v;
});
$parcel$export($4564c6c10d1690b3$exports, "spectrum-Link--secondary", function () {
  return $4564c6c10d1690b3$export$ab09ed292dcb9a79;
}, function (v) {
  return $4564c6c10d1690b3$export$ab09ed292dcb9a79 = v;
});
$parcel$export($4564c6c10d1690b3$exports, "spectrum-Link--overBackground", function () {
  return $4564c6c10d1690b3$export$679b6267148797da;
}, function (v) {
  return $4564c6c10d1690b3$export$679b6267148797da = v;
});
$parcel$export($4564c6c10d1690b3$exports, "spectrum-Link--quiet", function () {
  return $4564c6c10d1690b3$export$81921ea93435e997;
}, function (v) {
  return $4564c6c10d1690b3$export$81921ea93435e997 = v;
});
var $4564c6c10d1690b3$export$d85dd8b94975f388;
var $4564c6c10d1690b3$export$b8813cd5d7824ce7;
var $4564c6c10d1690b3$export$f39a09f249340e2a;
var $4564c6c10d1690b3$export$d35bc1e505d1ebbf;
var $4564c6c10d1690b3$export$ab09ed292dcb9a79;
var $4564c6c10d1690b3$export$679b6267148797da;
var $4564c6c10d1690b3$export$81921ea93435e997;
$4564c6c10d1690b3$export$d85dd8b94975f388 = "spectrum-Link_5a03c7";
$4564c6c10d1690b3$export$b8813cd5d7824ce7 = "is-hovered_5a03c7";
$4564c6c10d1690b3$export$f39a09f249340e2a = "focus-ring_5a03c7";
$4564c6c10d1690b3$export$d35bc1e505d1ebbf = "is-disabled_5a03c7";
$4564c6c10d1690b3$export$ab09ed292dcb9a79 = "spectrum-Link--secondary_5a03c7";
$4564c6c10d1690b3$export$679b6267148797da = "spectrum-Link--overBackground_5a03c7";
$4564c6c10d1690b3$export$81921ea93435e997 = "spectrum-Link--quiet_5a03c7";

function $3c5235ac12f2c9bb$export$a6c7ac8248d6e38a(props) {
  var _$11MUV$classNames;

  props = $11MUV$useProviderProps(props);
  props = $11MUV$useSlotProps(props, 'link');
  var _props = props,
      _props$variant = _props.variant,
      variant = _props$variant === void 0 ? 'primary' : _props$variant,
      isQuiet = _props.isQuiet,
      children = _props.children,
      // @ts-ignore
  href = _props.href;

  var _$11MUV$useStyleProps = $11MUV$useStyleProps(props),
      styleProps = _$11MUV$useStyleProps.styleProps;

  var _$11MUV$useHover = $11MUV$useHover({}),
      hoverProps = _$11MUV$useHover.hoverProps,
      isHovered = _$11MUV$useHover.isHovered;

  if (href) console.warn('href is deprecated, please use an anchor element as children');
  var ref = $11MUV$useRef();

  var _$11MUV$useLink = $11MUV$useLink(_objectSpread(_objectSpread({}, props), {}, {
    elementType: typeof children === 'string' ? 'span' : 'a'
  }), ref),
      linkProps = _$11MUV$useLink.linkProps;

  return /*#__PURE__*/$11MUV$react.createElement($11MUV$FocusRing, {
    focusRingClass: $11MUV$classNames( /*@__PURE__*/$parcel$interopDefault($4564c6c10d1690b3$exports), 'focus-ring')
  }, /*#__PURE__*/$11MUV$react.cloneElement($11MUV$getWrappedElement(children), _objectSpread(_objectSpread(_objectSpread({}, styleProps), $11MUV$mergeProps(linkProps, hoverProps)), {}, {
    ref: ref,
    className: $11MUV$classNames( /*@__PURE__*/$parcel$interopDefault($4564c6c10d1690b3$exports), 'spectrum-Link', (_$11MUV$classNames = {
      'spectrum-Link--quiet': isQuiet
    }, _defineProperty(_$11MUV$classNames, "spectrum-Link--".concat(variant), variant), _defineProperty(_$11MUV$classNames, 'is-hovered', isHovered), _$11MUV$classNames), styleProps.className)
  })));
}

export { $3c5235ac12f2c9bb$export$a6c7ac8248d6e38a as Link };